import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import emailjs from "emailjs-com";
import "./ContactPageForm.css";

const ContactPageForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    date: new Date().toISOString().split("T")[0], // Current date
    providerType: "",
    serviceType: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://api.dremerz.net/api/Project_15_Myrtle_Rcm_ContactPageForm_SavedDetails",
        { ...formData }
      );

      alert("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        providerType: "",
        serviceType: "",
      }); // Reset form
    } catch (error) {
      console.error("Error submitting form", error);
    }
  };

  return (
    <div className="">
      <div className="ContactPageForm-container">
        <Row className="ContactPageForm-wrapper">
          {/* Left Section */}
          <Col xs={12} md={5} className="ContactPageForm-info mb-4 mb-md-0">
            <div>
              <h5 className="ContactPageForm-title">📞 Phone</h5>
              <p>+1(512)6416014</p>
            </div>
            <div>
              <h5 className="ContactPageForm-title">📧 Email</h5>
              <p>enquiry@myrtlercm.com</p>
            </div>
            <div>
              <h5 className="ContactPageForm-title">📍 Location</h5>
              <span className="ContactPageForm-title">INDIA OFFICE</span>
              <p>
                106, SINDHU PLAZA 100 FEET ROAD MUDALIARPET PONDICHERRY 605004
              </p>

              <span className="ContactPageForm-title">U.S. OFFICE</span>
              <p>8, The Green Suite B, Dover, DE 19901</p>
            </div>
          </Col>

          {/* Right Section - Form */}
          <Col xs={12} md={7}>
            <Form onSubmit={handleSubmit} className="ContactPageForm">
              <Form.Group>
                <Form.Label>
                  Name <span>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ marginBottom: "10px" }}
                />
              </Form.Group>

              <Row>
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Email <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{ marginBottom: "10px" }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Phone Number <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      style={{ marginBottom: "10px" }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Are you a? <span>*</span>
                    </Form.Label>
                    <Form.Select
                      name="providerType"
                      value={formData.providerType}
                      onChange={handleChange}
                      required
                      style={{ marginBottom: "10px" }}
                    >
                      <option value="">Select an option</option>
                      <option value="Provider">Provider</option>
                      <option value="RCM company">RCM company</option>
                      <option value="Business Consultant">
                        Business Consultant
                      </option>
                      <option value="Others">Others</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Services looking out for <span>*</span>
                    </Form.Label>
                    <Form.Select
                      name="serviceType"
                      value={formData.serviceType}
                      onChange={handleChange}
                      required
                      style={{ marginBottom: "10px" }}
                    >
                      <option value="">Select a service</option>
                      <option value="Billing">Billing</option>
                      <option value="Business Consulting">
                        Business Consulting
                      </option>
                      <option value="RCM tools/applications">
                        RCM tools/applications
                      </option>
                      <option value="Not listed here">Not listed here</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group>
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={3}
                  style={{ marginBottom: "10px" }}
                />
              </Form.Group>

              <Button type="submit" className="ContactPageForm-button">
                SUBMIT
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContactPageForm;
